import { docAdd } from "@/apis/doc";
import { Doc, DocTypeEnum } from "@/types/doc";
import { WFile } from "@/types/file";

export const getLogAttachments = (doc: Doc | null | undefined): Doc[] => {
  if (doc?.nodeType === DocTypeEnum.LEAF && doc.fileId) {
    return [doc];
  }

  return (doc?.subs ?? []).filter(
    (item) => item.nodeType === DocTypeEnum.LEAF && !!item.fileId,
  );
};

export const createLogAttachmentDocument = async (
  files: WFile[],
): Promise<Doc | null> => {
  if (files.length === 0) return null;

  const createLeaf = (file: WFile, pId?: string) =>
    docAdd({
      pId,
      name: file.name,
      suffix: file.suffix,
      fileId: file.id,
      nodeType: DocTypeEnum.LEAF,
    });

  if (files.length === 1) {
    return createLeaf(files[0]);
  }

  const root = await docAdd({
    name: Date.now().toString(),
    nodeType: DocTypeEnum.NODE,
  });
  const attachments = await Promise.all(
    files.map((file) => createLeaf(file, root.id)),
  );

  return {
    ...root,
    subs: attachments,
  };
};
